/**
 * Which public surfaces may show the site-wide secondary CTAs and Simply AI.
 *
 * Excluded: admin, authentication, thank-you/confirmation pages, private or
 * noindex utility routes, and raw API paths. Everything else — including every
 * business-purpose DSCR state, county and city landing page outside FL/CO — is
 * eligible. Business-purpose investor content is available across the approved
 * footprint; only consumer/owner-occupied residential brokerage is limited to
 * Florida and Colorado, and that limit is expressed in page copy and in the
 * assistant's guardrails, not by hiding the assistant.
 */

export const EXCLUDED_PATH_PREFIXES = [
  "/admin",
  "/auth",
  "/api",
  "/apply/thanks",
  "/thank-you",
  "/unsubscribe",
  "/preferences",
] as const;

export const EXCLUDED_EXACT_PATHS = ["/offline"] as const;

function normalize(pathname: string): string {
  if (!pathname) return "/";
  const clean = pathname.split("?")[0]!.split("#")[0]!;
  return clean.length > 1 ? clean.replace(/\/+$/, "") : clean;
}

/** True for public, indexable pages that should carry site-wide modules. */
export function isEligiblePublicPath(pathname: string): boolean {
  const p = normalize(pathname);
  if ((EXCLUDED_EXACT_PATHS as readonly string[]).includes(p)) return false;
  return !EXCLUDED_PATH_PREFIXES.some((prefix) => p === prefix || p.startsWith(`${prefix}/`));
}

/** The Preferred Sources control follows the same eligibility rule. */
export const isPreferredSourceEligible = isEligiblePublicPath;

/** Simply AI follows the same eligibility rule. */
export const isSimplyAiEligible = isEligiblePublicPath;
